'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _reactDom = require('react-dom');

var _UIHelpIcon = require('../icon/UIHelpIcon');

var _UIHelpIcon2 = _interopRequireDefault(_UIHelpIcon);

var _UIFormLabel = require('./UIFormLabel');

var _UIFormLabel2 = _interopRequireDefault(_UIFormLabel);

var _UICheckbox = require('../input/UICheckbox');

var _UICheckbox2 = _interopRequireDefault(_UICheckbox);

var _UITooltip = require('../tooltip/UITooltip');

var _UITooltip2 = _interopRequireDefault(_UITooltip);

var _PlacementConstants = require('../tooltip/PlacementConstants');

var _elements = require('../elements');

var _validateUIFormControlValidationMessage = require('./utils/validateUIFormControlValidationMessage');

var _validateUIFormControlValidationMessage2 = _interopRequireDefault(_validateUIFormControlValidationMessage);

var _decorators = require('../utils/propTypes/decorators');

var _renderProp = require('../utils/propTypes/renderProp');

var _underscore = require('../utils/underscore');

var _FieldsetContext = require('../context/FieldsetContext');

var _HoverProvider = require('../providers/HoverProvider');

var _HoverProvider2 = _interopRequireDefault(_HoverProvider);

var _sizes = require('HubStyleTokens/sizes');

var _deprecated = require('../utils/propTypes/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var InlineFormLabel = (0, _styledComponents2.default)(_UIFormLabel2.default).withConfig({
  displayName: 'UIFormControl__InlineFormLabel'
})(['&&{display:inline;}']);

var LabelWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'UIFormControl__LabelWrapper'
})(['&&{align-items:baseline;padding-bottom:', ';padding-top:', ';}'], function (_ref) {
  var hasLabel = _ref.hasLabel,
      hasHelp = _ref.hasHelp;
  return (hasLabel || hasHelp) && _sizes.LABEL_DEFAULT_PADDING_BOTTOM;
}, function (_ref2) {
  var hasLabel = _ref2.hasLabel,
      hasHelp = _ref2.hasHelp;
  return hasHelp && !hasLabel && _sizes.LABEL_DEFAULT_PADDING_TOP;
});

var sizeClasses = {
  small: 'private-form__control--small',
  medium: ''
};

var getClassName = function getClassName(className, error, label, _size, verticalSeparation) {
  return (0, _classnames2.default)('private-form__set', className, sizeClasses[_size], {
    'private-form__set--error': !!error,
    'private-form__set--no-label': !label,
    'private-form__set--flush': verticalSeparation === 'flush',
    'private-form__set--separated': verticalSeparation === 'separated'
  });
};

var getClosestDescendantId = function getClosestDescendantId(child) {
  var element = child;
  var id = element.props.id;
  while (id == null) {
    try {
      element = _react.Children.only(element.props.children);
    } catch (e) {
      break;
    }
    id = element.props.id;
  }
  return id;
};

var getDerivedId = function getDerivedId(inputProps, id) {
  var IDs = Object.keys(inputProps).filter(function (prop) {
    return inputProps[prop];
  }).map(function (prop) {
    if (!inputProps[prop]) return '';
    return id + '-' + prop;
  });
  if (IDs.length > 0) return IDs.join(' ');
  return undefined;
};

var getHtmlFor = function getHtmlFor(propValue, children) {
  var firstChild = _react.Children.only(children);

  if (propValue) {
    return propValue;
  }

  if (firstChild) {
    return getClosestDescendantId(firstChild) || name;
  }

  return null;
};

var renderInput = function renderInput(ariaLabel, ariaLabelledBy, children, description, error, help, required, validationMessage, disabledFieldset, fallbackId) {
  var child = _react.Children.only(children);
  var origRequired = child.props.required;

  // if the child input doesn't declare `required`, pass it down

  var newRequired = required === true ? true : origRequired;
  var newError = error === true ? 'true' : undefined;

  var cloneProps = {
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledBy,
    required: newRequired,
    'aria-invalid': newError,
    'aria-required': newRequired
  };

  // only add id prop if it doesn't have it already
  var descendantId = getClosestDescendantId(child);
  if (!descendantId) {
    cloneProps.id = fallbackId;
  }

  // only add error prop if there is an error, to avoid potential "Unknown prop" warnings
  if (error) {
    cloneProps.error = !!error;
  }

  // disable the input if we're within a disabled fieldset (#3356)
  if (disabledFieldset) {
    cloneProps.disabled = true;
  }

  // aggregate IDs to pass into aria-describedby
  var newDescribedBy = getDerivedId({ validationMessage: validationMessage, help: help, description: description }, cloneProps.id);

  // derive ID and spread back into cloneProps
  var describedCloneProps = {
    'aria-describedby': newDescribedBy
  };

  var mergedCloneProps = _extends({}, cloneProps, describedCloneProps);

  return (0, _react.cloneElement)(child, mergedCloneProps);
};

var renderLabel = function renderLabel(children, label, labelClassName, error, htmlFor, labelId, required, tooltip, tooltipPlacement, tooltipProps, renderedInput, handleLabelClick, disabledFieldset, FormLabel, refCallback) {
  if (!label) return null;

  var _Children$only$props = _react.Children.only(children).props,
      childDisabled = _Children$only$props.disabled,
      childReadOnly = _Children$only$props.readOnly;

  var renderedLabel = _react2.default.createElement(
    FormLabel,
    {
      className: (0, _classnames2.default)(labelClassName, {
        'private-form__label--with-tooltip': !!tooltip
      }),
      error: !!error,
      htmlFor: getHtmlFor(htmlFor, renderedInput),
      id: labelId,
      onClick: handleLabelClick,
      readOnly: childDisabled || childReadOnly || disabledFieldset,
      required: required,
      ref: refCallback
    },
    label
  );

  return tooltip ? _react2.default.createElement(
    _UIHelpIcon2.default,
    {
      className: 'private-form__help-tooltip',
      title: tooltip,
      tooltipPlacement: tooltipPlacement,
      tooltipProps: tooltipProps
    },
    renderedLabel
  ) : renderedLabel;
};

var renderHelp = function renderHelp(help, helpClassName, renderedInputId) {
  if (!help) return null;

  return _react2.default.createElement(
    _elements.Small,
    {
      className: (0, _classnames2.default)('private-form__inlinehelp', helpClassName),
      id: getDerivedId({ help: help }, renderedInputId),
      tabIndex: -1,
      use: 'help'
    },
    help
  );
};

var renderValidation = function renderValidation(error, validationMessage, inputId) {
  var validationClass = 'private-form__validation';

  if (validationMessage) {
    (0, _validateUIFormControlValidationMessage2.default)({ error: error, validationMessage: validationMessage });

    return _react2.default.createElement(
      _elements.Small,
      {
        className: validationClass,
        id: getDerivedId({ validationMessage: validationMessage }, inputId),
        tabIndex: -1,
        use: error ? 'error' : 'success'
      },
      validationMessage
    );
  }

  return null;
};

var renderCounter = function renderCounter(characterCount) {
  return characterCount == null ? null : _react2.default.createElement(
    _elements.Small,
    { className: 'private-form__counter' },
    characterCount
  );
};

var renderDescription = function renderDescription(description, inputId) {
  if (!description) return null;

  _devLogger2.default.warn({
    message: 'UIFormControl: the `description` prop has been deprecated. Please use the `help` prop instead.',
    key: 'UIFormControl: description prop'
  });

  return _react2.default.createElement(
    _elements.Small,
    {
      className: 'private-form__description',
      id: getDerivedId({ description: description }, inputId),
      tabIndex: -1,
      use: 'help'
    },
    description
  );
};

/**
 * Group a form field, label, notes, and errors/alerts together
 **/
var UIFormControl = (0, _createReactClass2.default)({
  displayName: 'UIFormControl',

  propTypes: {
    /**
     * Instructional text to display with the field label
     **/
    'aria-label': _propTypes2.default.string,

    /** List of IDs that label this input */
    'aria-labelledby': _propTypes2.default.string,

    /**
     * Display character count metadata beneath the input
     */
    characterCount: _propTypes2.default.node,

    /**
     * Pass the form input as a child. Label will be linked by provided ID, or
     * a random unique ID will be assigned to the input for linking.
     **/
    children: _propTypes2.default.node.isRequired,

    /**
     * Detailed description of component. Similar to `help` but more in-depth
     **/
    description: (0, _deprecated2.default)(_propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool])),

    /**
     * `true` indicates this field is in an error state
     **/
    error: _propTypes2.default.bool,

    /**
     * Label render prop
     */
    FormLabel: (0, _renderProp.getPropType)(_UIFormLabel2.default),

    /**
     * Message to be displayed at the bottom of the input
     *
     * By default the text is green
     * If `error` is set to `true` then the text is red
     **/
    validationMessage: _propTypes2.default.node,

    /**
     * Instructional text to display with the field label
     **/
    help: _propTypes2.default.node,

    /**
     * Class name for the <span> wrapper around the `text` prop
     **/
    helpClassName: _propTypes2.default.string,

    /**
     * `id` attribute of the input field you want label to be bound to
     *
     * By default, the `<label />` will be linked to the embedded `<input />`
     * using the `for` attribute. Use this if you need to override that behavior
     **/
    htmlFor: _propTypes2.default.string,

    /**
     * Renders a clickable <UIFormLabel /> alongside input with this text as content
     **/
    label: _propTypes2.default.node,

    /**
     * Class name for the rendered <UIFormLabel /> component
     **/
    labelClassName: _propTypes2.default.string,

    /**
     * Renders a UITooltip around the rendered <UIFormLabel /> component
     **/
    labelTooltip: _propTypes2.default.node,

    /**
     * `true` indicates the field is required and will be styled accordingly
     **/
    required: _propTypes2.default.bool.isRequired,

    /**
     * Instructional text to display with the the '?' icon and tooltip
     **/
    tooltip: _propTypes2.default.node,

    /**
     * Placement of the tooltip
     **/
    tooltipPlacement: _propTypes2.default.oneOf(_PlacementConstants.PLACEMENTS).isRequired,

    /**
     * Props passed through to the tooltip
     **/
    tooltipProps: _UIHelpIcon2.default.propTypes.tooltipProps,

    /**
     * @private
     * Enables smaller sized inputs. This is not supported for all input types.
     **/
    _size: _propTypes2.default.oneOf(Object.keys(sizeClasses)),

    /**
     * @private
     * Used internally to help determine open state of `labelTooltip`
     **/
    hovered: (0, _decorators.hidden)(_propTypes2.default.bool),

    /**
     * Allows adjustment of automatic vertical spacing
     **/
    verticalSeparation: _propTypes2.default.oneOf(['flush', 'separated'])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      FormLabel: InlineFormLabel,
      required: false,
      tooltipPlacement: 'top',
      _size: 'medium'
    };
  },
  getInitialState: function getInitialState() {
    return {
      labelTarget: null
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this._fallbackId = 'UIFormControl-' + (0, _underscore.uniqueId)();
    this._labelId = 'UIFormControl-label-' + (0, _underscore.uniqueId)();
  },
  handleLabelClick: function handleLabelClick(evt) {
    var labeledElement = document.getElementById(evt.target.htmlFor);
    var labelableTagNames = ['BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'];
    if (labeledElement && labelableTagNames.indexOf(labeledElement.tagName) === -1) {
      labeledElement.click();
    }
  },
  labelRefCallback: function labelRefCallback(ref) {
    this.setState({ labelTarget: (0, _reactDom.findDOMNode)(ref) });
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        ariaLabel = _props['aria-label'],
        ariaLabelledBy = _props['aria-labelledby'],
        characterCount = _props.characterCount,
        children = _props.children,
        className = _props.className,
        description = _props.description,
        error = _props.error,
        FormLabel = _props.FormLabel,
        validationMessage = _props.validationMessage,
        help = _props.help,
        helpClassName = _props.helpClassName,
        __hovered = _props.hovered,
        htmlFor = _props.htmlFor,
        label = _props.label,
        labelClassName = _props.labelClassName,
        labelTooltip = _props.labelTooltip,
        required = _props.required,
        tooltip = _props.tooltip,
        tooltipPlacement = _props.tooltipPlacement,
        tooltipProps = _props.tooltipProps,
        _size = _props._size,
        verticalSeparation = _props.verticalSeparation,
        rest = _objectWithoutProperties(_props, ['aria-label', 'aria-labelledby', 'characterCount', 'children', 'className', 'description', 'error', 'FormLabel', 'validationMessage', 'help', 'helpClassName', 'hovered', 'htmlFor', 'label', 'labelClassName', 'labelTooltip', 'required', 'tooltip', 'tooltipPlacement', 'tooltipProps', '_size', 'verticalSeparation']);

    var labelTarget = this.state.labelTarget;


    if (!label && !ariaLabel && !ariaLabelledBy && _react.Children.only(children).type !== _UICheckbox2.default) {
      _devLogger2.default.warn({
        message: "UIFormControl: For better accessibility, if you're going to omit `label`, please include an `aria-label` or `aria-labelledby` property.",
        key: 'UIFormControl: label'
      });
    }

    return _react2.default.createElement(
      _HoverProvider2.default,
      this.props,
      function (hoverProviderProps) {
        return _react2.default.createElement(
          _FieldsetContext.FieldsetContextConsumer,
          null,
          function (fieldsetContext) {
            var hovered = hoverProviderProps.hovered,
                hoverProviderRestProps = _objectWithoutProperties(hoverProviderProps, ['hovered']);

            var classes = getClassName(className, error, label, _size, verticalSeparation);
            var renderedInput = renderInput(ariaLabel, ariaLabelledBy || _this._labelId, children, description, error, help, required, validationMessage, fieldsetContext.disabled, _this._fallbackId);

            var inputId = renderedInput && renderedInput.props && renderedInput.props.id;

            return _react2.default.createElement(
              'div',
              _extends({ className: classes }, rest, hoverProviderRestProps),
              _react2.default.createElement(
                'div',
                { className: 'private-form__control-wrapper' },
                _react2.default.createElement(
                  LabelWrapper,
                  {
                    className: 'private-form__label-wrapper',
                    hasLabel: label != null,
                    hasHelp: help != null
                  },
                  renderLabel(children, label, labelClassName, error, htmlFor, _this._labelId, required, tooltip, tooltipPlacement, tooltipProps, renderedInput, _this.handleLabelClick, fieldsetContext.disabled, FormLabel, _this.labelRefCallback),
                  renderHelp(help, helpClassName, inputId)
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'private-form__input-wrapper' },
                  _react2.default.createElement(
                    _UITooltip2.default,
                    {
                      title: labelTooltip,
                      open: hovered || undefined,
                      placement: 'top right',
                      autoPlacement: false,
                      targetAttachment: 'top left',
                      _insetAdjustment: -1 * parseInt(_sizes.INPUT_DEFAULT_PADDING_X, 10),
                      target: labelTarget
                    },
                    renderedInput
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'private-form__meta' },
                  _react2.default.createElement(
                    'div',
                    { className: 'private-form__messages' },
                    renderValidation(error, validationMessage, inputId)
                  ),
                  renderCounter(characterCount)
                ),
                renderDescription(description, inputId)
              )
            );
          }
        );
      }
    );
  }
});

exports.default = UIFormControl;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/form/UIFormControl.js
// module id = 573
// module chunks = 177